import script from "./HrSplitBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./HrSplitBtn.vue?vue&type=script&setup=true&lang=js"

import "./HrSplitBtn.vue?vue&type=style&index=0&id=6c9c4b89&lang=scss&scoped=true"
import "./HrSplitBtn.vue?vue&type=style&index=1&id=6c9c4b89&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c9c4b89"]])

export default __exports__
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtnDropdown,QBtnGroup,QBtn});
